import { E_Lang, T_Lang } from "@/i18n/types"
import { ICustomServiceConfig } from "./customerManager.types"

export enum E_CompanyLogoStatus {
    Close = 0,
    Open = 1,
}

type ImageFieldId<T extends string> = {
    [P in `${T}Id`]: number
}

type ImageField<T extends string> = ImageFieldId<T> & {
    [P in `${T}Url`]: string
}

export type PlatformImageKinds =
    'largeScreenImg' | // 大屏图片
    'largeScreenLogo' | // 大屏LOGO图片
    'logo' | // 系统LOGO图片
    'platform' | // 系统名称图
    'pageFooter' | // 周报页脚
    'pageHeader' | // 周报页眉    
    'weeklyCover' |  // 周报封面图片
    'systemLogo' |
    'companyLogo'    //公司logo


export type AppImageKinds =
    'appManageLogo' | //APP管理
    'appPlatformLogo' | // 云平台管理
    'appUserLogo' //  APP用户头像默认图片


export interface IPlatformCompanySettingParams {
    languageType: T_Lang
    companyId?: number
    platformCompanyId: number
}

export type AllImageKinds = PlatformImageKinds | AppImageKinds

export type IPlatformCompanySettingData = {
    createTime: string
    languageType: T_Lang
    id: number

    /**
     * 是否使用公司logo
     */
    companyLogoStatus: E_CompanyLogoStatus

    /**
     * 公司id
     */
    companyId: number
    /**
     * 平台公司id
     */
    parentCompanyId: number
    /**
     * 系统简称
     */
    systemName: string

    /**
     * 大屏名称
     */
    largeScreenName: string

    /**
     * 周报页眉
     */
    pageHeaderDesc: string
    /**
     * 周报页脚
     */
    pageFooterDesc: string
    /**
     * 系统名称
     */
    systemCompanyName: string

    
} & ImageField<AllImageKinds>



export interface IPlatformCompanyGetCompanyParams {
    companyId?: number
    languageType: E_Lang
    platformCompanyId: number
}    

/** 登录后进入的平台入口 */
export enum E_PlatformPortalEntry {
    Portal = 'PORTAL',
    Monitor = 'MONITOR',
    LargeScreen = 'LARGE_SCREEN',
    None = 'NONE',
    Admin = 'ADMIN',
}

/** 门户中可进入的业务系统 */
export interface IPlatformPortalSystem {
    systemCode: E_PlatformPortalEntry
    systemName: string
    description: string
    features: string[]
}

/** 当前登录用户的门户及入口配置 */
export interface IPlatformPortalData {
    loginEntry: E_PlatformPortalEntry
    serviceConfig?: ICustomServiceConfig
    /** 仅设备监测和智慧运维大屏同时开通时为 true */
    showPortal: boolean
    systems: IPlatformPortalSystem[]
}


export type IPlatformCompanyGetCompanyData = IPlatformCompanySettingData


export type IPlatformCompanySettingSaveParams = {
    id?: number
    parentCompanyId: number
    systemName: string
    
    /**
     * 大屏名称
     */
    largeScreenName: string

    /**
     * 周报页眉
     */
    pageHeaderDesc: string
    /**
     * 周报页脚
     */
    pageFooterDesc: string
    /**
     * 系统名称
     */
    systemCompanyName: string
} & ImageFieldId<AllImageKinds>
